import { Box, Drawer, List, ListItem } from "@mui/material";
import { SnackbarProvider } from "notistack";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useIdleTimer } from "react-idle-timer";
import { NavLink } from "react-router-dom";
import BusClaimApiService from "../adapters/xhr/BusClaimApiService";
import { MyLoadingIndicator } from "../components/my-loading-indicator/MyLoadingIndicator";
import { lngs, MaximumIdleTimeInMinute, UserRoles } from "../Constant";
import SnackbarUtils, { SnackbarUtilsConfigurator } from "../SnackbarUtils";
import { BusThemeProvider } from "./BusThemeProvider";
import authService from "../components/api-authorization/AuthorizeService";

export const BusAdminLayout = (props) => {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    i18n.changeLanguage(lngs.sv.code);
  }, []);

  const getFraud = async () => {
    let response = await BusClaimApiService.getFraud();
    if (response.data?.exceedMaxClaimsIn24Hour || response.data?.exceedMaxClaimsDuring7Days || response.data?.exceedMaxClaimsDuring30Days) {
      SnackbarUtils.warning(t("check_fraud_report"));
    }
    if (response.data?.exceedMaxOpenClaims) {
      SnackbarUtils.warning(t("check_overview"));
    }
  };

  useEffect(() => {
    getFraud();
  }, []);

  const isOnOverviewPage = (match, location) => {
    if (location.pathname === "/" || location.pathname === "/buses" || location.pathname === "/buses/" || match?.isExact === true) return true;
  };

  const logout = () => {
    window.location.href = `/buses/authentication/logout`;
  };

  const onIdle = () => {
    logout();
  };

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    timeout: MaximumIdleTimeInMinute * 60 * 1000,
    throttle: 500,
  });

  return (
    <BusThemeProvider>
      <SnackbarProvider>
        <SnackbarUtilsConfigurator />
        <Box sx={{ display: "flex" }} flexDirection="column">
          <Drawer variant="permanent" anchor="left" PaperProps={{ style: { width: "150px", fontSize: "1rem" } }}>
            <h4 style={{ padding: "1rem 1rem 0 1rem" }}>{t("menu")}</h4>
            <List>
              <ListItem>
                <NavLink to="/buses/overview" isActive={isOnOverviewPage} style={{ color: "black" }} activeClassName="text-primary">
                  {t("overview")}
                </NavLink>
              </ListItem>
              <ListItem>
                <NavLink to="/buses/statistics" style={{ color: "black" }} activeClassName="text-primary">
                  {t("statistics")}
                </NavLink>
              </ListItem>
              <ListItem>
                <NavLink to="/buses/reports" style={{ color: "black" }} activeClassName="text-primary">
                  {t("reports")}
                </NavLink>
              </ListItem>
              <ListItem>
                <NavLink to="/buses/settings" style={{ color: "black" }} activeClassName="text-primary">
                  {t("settings")}
                </NavLink>
              </ListItem>
              <ListItem>
                <NavLink to="/buses/approval-job" style={{ color: "black" }} activeClassName="text-primary">
                  {t("approval_job")}
                </NavLink>
              </ListItem>
              <ListItem hidden={authService._user.profile.role !== UserRoles.SuperAdmin}>
                <NavLink to="/buses/account-management" style={{ color: "black" }} activeClassName="text-primary">
                  {t("account_management")}
                </NavLink>
              </ListItem>
              <ListItem>
                <NavLink to="/buses/authentication/logout" style={{ color: "black" }} activeClassName="text-primary">
                  {t("logout")}
                </NavLink>
              </ListItem>
            </List>
          </Drawer>
          <Box component="main" marginLeft={`150px`}>
            {props.children}
          </Box>
        </Box>
      </SnackbarProvider>
      <MyLoadingIndicator />
    </BusThemeProvider>
  );
};
